import styled from 'styled-components';
import {Section as SectionStyles,BtnFlex, Btn, Container as ContainerStyles, Grid} from '../ReUsableStyles';
import {Link} from 'react-router-dom';
import { Link as LinkScroll } from "react-scroll";


export const Section = styled.section`
    ${SectionStyles};

`;
export const Container = styled.div`
    ${ContainerStyles};
    ${Grid};
    // justify-self:center;
    gap: 1rem;
`;
export const Content = styled.div`
    ${Grid};
    grid-template-columns: .5fr 3fr;
    padding-top: 3.5rem;
    align-items: center;

`;
export const Social = styled.div`
    display: grid;
    grid-template-columns: max-content;
    row-gap: 1rem;
`;
export const SocialIcon = styled(Link)`
    font-size: 1.25rem;
    color: var(--first-color);
    &:hover{
        color: var(--first-color-alt);
    }
`;
export const HomeImg = styled.div`
    .home__blob{
        width: 200px;
        fill: var(--first-color);
    }
    .home_blob-img{
        width:170px;
    }
`;

export const HomeData = styled.div`
    grid-column: 1/3;
`;

export const HomeTitle = styled.h1`
    font-size: var(--big-font-size);
`;

export const HomeSubtitle = styled.h3`
    font-size: var(--h3-font-size);
    color: var(--text-color);
    font-weight: var(--font-medium);
    margin-bottom: var(--mb-0-75);
`;

export const HomeDescription = styled.p`
    margin-bottom: var(--mb-2);
`;

export const Button = styled(LinkScroll)`
    ${BtnFlex};
    ${Btn};
`;

export const HomeScroll = styled.div`
    display:none;
`;

export const HomeScrollBtn = styled(LinkScroll)`
    ${BtnFlex};
    cursor:pointer;
    color: var(--first-color);
    transition: .3s;
    &:hover{
        transform: translateY(.25rem);
    }
    .home__scroll-mouse{
        font-size: 2rem;
    }
    .home__scroll-arrow{
        font-size: 1.25rem;
    }
`;

export const HomeScrollName = styled.span`
    font-size: var(--small-font-size);
    color: var(--title-color);
    font-weight: var(--font-medium);
    margin-right: var(--mb-0-25);
`;